import request from '@/static/js/request'

function site_name() {
    return request({
        url: 'common_config',
        method: 'post',
    }).then(res=>{
        return res.data;
    });
}
export { site_name }
